module.exports = __webpack_public_path__ + "8075a6be6216ae3a72915ed256e88eaa.svg";